module.exports = __webpack_public_path__ + "media/LandingPageAssets/RedFlame-44ff9526.png";